export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'e8351382-2296-44a7-bdf6-a75de0131b6a';
export const MODAL_CLOSE_SEC = 2.5;


